import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-update-toast',
    templateUrl: './app-update-toast.component.html',
    styleUrls: ['./app-update-toast.component.scss'],
    imports: [TranslatePipe]
})
export class AppUpdateToastComponent extends Toast {
  reloadApp(): void {
    window.location.reload();
  }
}
